import {
  CHANGE_SELECTED_STRUCTURE,
  RESET_STRUCTURES_STATE,
} from "features/budget/company-structure/rdx/company-structure.actions";

const INITIAL_STATE = {
  companyStructure: null,
};

// eslint-disable-next-line default-param-last
const companyStructureRdxReducer = (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case CHANGE_SELECTED_STRUCTURE:
      return {
        ...state,
        companyStructure: {
          id: payload.structureID,
          name: payload.structureName,
        },
      };
    case RESET_STRUCTURES_STATE:
      return { ...INITIAL_STATE };
    default:
      return state;
  }
};

export default companyStructureRdxReducer;
